import React from 'react';
import './Button.style.css';

const Button = ({
  children,
  style,
  hovered = false,
  onClick = () => {},
  type = 'primary',
  className,
  disabled = false,
}) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <button
      className={`jm_button ${hovered ? 'hovered' : ''} ${
        disabled ? 'disabled' : ''
      } ${type} ${className}`}
      style={{ ...style }}
      onClick={() => onClick()}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
